var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pa-section pa-section-terms"},[_c('div',{staticClass:"pa-golden-wide-box pa-terms"},[_c('p',{staticClass:"title"},[_vm._v("プライバシーポリシー")]),_c('div',{staticClass:"content pa-content"},[_c('PAPrivacy')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }